import React, { useEffect, useState, useRef } from 'react';
import { DayPicker } from "react-day-picker";
import { pt } from "react-day-picker/locale";
import api from '../../../config/axios';

import AbrirCaixaModal from './modals/AbrirCaixa';
import FecharCaixaModal from './modals/FecharCaixa';
import OperacoesCaixaModal from './modals/OperacoesCaixa';
import ReabrirCaixaModal from './modals/ReabrirCaixa';
import SangriaSuprimentoModal from './modals/SangriaSuprimentoModal';

import { FaPlus, FaCheckCircle, FaEye, FaArrowDown, FaArrowUp } from 'react-icons/fa';

const Caixas = () => {
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState('abertos');

    const [caixas, setCaixas] = useState([]);
    const [selectedDay, setSelectedDay] = useState(new Date());
    const [currentMonth, setCurrentMonth] = useState(new Date());
    const lastSelectedDay = useRef(selectedDay);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalFecharCaixaOpen, setIsModalFecharCaixaOpen] = useState(false);
    const [isModalOperacoesOpen, setIsModalOperacoesOpen] = useState(false);
    const [isModalReabrirCaixaOpen, setIsModalReabrirCaixaOpen] = useState(false);
    const [isModalSangriaSuprimentoOpen, setIsModalSangriaSuprimentoOpen] = useState(false);
    const [tipoOperacao, setTipoOperacao] = useState('');
    const [caixaSelecionado, setCaixaSelecionado] = useState(null);

    const fetchCaixas = async () => {
        try {
            if (activeTab === 'abertos') {
                const response = await api.get('/caixas?status=aberto');
                setCaixas(response.data);
            } else {
                const dataFormatada = selectedDay.toISOString().split('T')[0];
                const response = await api.get(`/caixas?status=fechado&dataInicio=${dataFormatada}&dataFim=${dataFormatada}`);
                setCaixas(response.data);
            }
        } catch (error) {
            setError(activeTab === 'abertos' ? 'Erro ao carregar os caixas em aberto.' : 'Erro ao carregar os caixas fechados.');
        }
    };

    useEffect(() => {
        fetchCaixas();
    }, [activeTab]);

    useEffect(() => {
        if (activeTab === 'historico' && selectedDay) {
            if (lastSelectedDay.current.toLocaleDateString() !== selectedDay.toLocaleDateString()) {
                lastSelectedDay.current = selectedDay;
                fetchCaixas();
            }
        }
    }, [selectedDay, activeTab]);

    const handleTabChange = (tab) => {
        setActiveTab(tab);
        setError(null);
    };

    const abrirModalFecharCaixa = (caixa) => {
        setCaixaSelecionado(caixa);
        setIsModalFecharCaixaOpen(true);
    };

    const abrirModalOperacoes = (caixa) => {
        setCaixaSelecionado(caixa);
        setIsModalOperacoesOpen(true);
    };

    const abrirModalReabrirCaixa = (caixa) => {
        setCaixaSelecionado(caixa);
        setIsModalReabrirCaixaOpen(true);
    };

    const abrirModalSangriaSuprimento = (caixa, tipo) => {
        setCaixaSelecionado(caixa);
        setTipoOperacao(tipo);
        setIsModalSangriaSuprimentoOpen(true);
    };

    const renderCaixaCard = (caixa, index) => {
        return (
            <div key={index} className="col">
                <div className="card h-100" style={{ fontSize: '14px' }}>
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start">
                            <div className="d-flex gap-3">
                                {caixa.colaborador.fotoum ? (
                                <img
                                    src={caixa.colaborador.fotoum}
                                    alt="Foto do responsável"
                                    className="rounded-circle"
                                    style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                                />
                                ) : (
                                    <></>
                                )}
                                <div>
                                    <p className="mb-1"><strong>Responsável:</strong> {caixa.colaborador.nome}</p>
                                    <p className="mb-1"><strong>E-mail:</strong> {caixa.colaborador.email}</p>
                                    <p className="mb-1"><strong>Abertura:</strong> {new Date(caixa.data_abertura).toLocaleString('pt-BR').replace(',', '')}</p>
                                    <p className="mb-1"><strong>Fechamento:</strong> {caixa.data_fechamento ? new Date(caixa.data_fechamento).toLocaleString('pt-BR').replace(',', '') : ''}</p>
                                    <p className="mb-1"><strong>Data Criação:</strong> {new Date(caixa.created_at).toLocaleString('pt-BR').replace(',', '')}</p>
                                    <p className="mb-1"><strong>Última Modificação:</strong> {new Date(caixa.updated_at).toLocaleString('pt-BR').replace(',', '')}</p>
                                    <p className="mb-1"><strong>Valor Inicial (Dinheiro):</strong> {parseFloat(caixa.valor_inicial_dinheiro).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                    <p className="mb-1"><strong>Valor Inicial (Cheque):</strong> {parseFloat(caixa.valor_inicial_cheque).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header header-custom-primary">
                                        <strong>Total em Caixa</strong>
                                    </div>
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between mb-2">
                                            <span>Dinheiro</span>
                                            <span>{parseFloat(caixa.total_dinheiro).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span>Cartão Crédito</span>
                                            <span>{parseFloat(caixa.total_credito).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span>Cartão Débito</span>
                                            <span>{parseFloat(caixa.total_debito).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span>Pix</span>
                                            <span>{parseFloat(caixa.total_pix).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span>Cheque</span>
                                            <span>{parseFloat(caixa.total_cheque).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span>Boleto</span>
                                            <span>{parseFloat(caixa.total_boleto || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span>TED</span>
                                            <span>{parseFloat(caixa.total_ted || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span>DOC</span>
                                            <span>{parseFloat(caixa.total_doc || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span>Cortesia</span>
                                            <span>{parseFloat(caixa.total_cortesia).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="mt-3">
                            {activeTab === 'abertos' && (
                                <div className="row g-2 mb-2">
                                    <div className="col-lg-6 col-12">
                                        <button 
                                            className="btn btn-outline-primary w-100"
                                            onClick={() => abrirModalSangriaSuprimento(caixa, 'sangria')}
                                        >
                                            <FaArrowDown /> Sangria
                                        </button>
                                    </div>
                                    <div className="col-lg-6 col-12">
                                        <button 
                                            className="btn btn-outline-primary w-100"
                                            onClick={() => abrirModalSangriaSuprimento(caixa, 'suprimento')}
                                        >
                                            <FaArrowUp /> Suprimento
                                        </button>
                                    </div>
                                </div>
                            )}
                            <div className="row g-2">
                                <div className="col-lg-6 col-12">
                                    <button className="btn btn-outline-primary w-100" onClick={() => abrirModalOperacoes(caixa)}>
                                        <FaEye /> Operações
                                    </button>
                                </div>
                                <div className="col-lg-6 col-12">
                                    {activeTab === 'abertos' ? (
                                        <button className="btn btn-outline-danger w-100" onClick={() => abrirModalFecharCaixa(caixa)}>
                                            <FaCheckCircle /> Fechar Caixa
                                        </button>
                                    ) : (
                                        <button className="btn btn-outline-danger w-100" onClick={() => abrirModalReabrirCaixa(caixa)}>
                                            <FaCheckCircle /> Reabrir Caixa
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const getEmptyMessage = () => {
        return activeTab === 'abertos'
            ? 'Não há caixas abertos para exibir.'
            : 'Não há caixas fechados para exibir nesta data.';
    };

    return (
        <div className="container-fluid">
            <div className="card">
                <div className="card-body">
                    <div className="row mt-3">
                        <div className="col-12">
                            <h4 className="fw-bold">Caixas</h4>
                        </div>
                    </div>

                    <ul className="nav nav-tabs mt-3">
                        <li className="nav-item">
                            <a
                                className={activeTab === 'abertos' ? 'nav-link active' : 'nav-link'}
                                aria-current="page"
                                onClick={() => handleTabChange('abertos')}
                                style={{ cursor: 'pointer' }}
                            >
                                Abertos
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className={activeTab === 'historico' ? 'nav-link active' : 'nav-link'}
                                aria-current="page"
                                onClick={() => handleTabChange('historico')}
                                style={{ cursor: 'pointer' }}
                            >
                                Histórico
                            </a>
                        </li>
                    </ul>

                    <div className="row mt-3 mb-3">
                        <div className="col-md-8 col-12">
                            {activeTab === 'abertos' && (
                                <button className="btn btn-outline-primary" onClick={() => setIsModalOpen(true)}>
                                    <FaPlus /> Abrir Caixa
                                </button>
                            )}
                        </div>
                    </div>

                    {activeTab === 'historico' && (
                        <div className="row mt-3">
                            <div className="d-lg-flex d-block align-items-start">
                                <div className="me-3">
                                    <DayPicker
                                        mode="single"
                                        locale={pt}
                                        selected={selectedDay}
                                        onSelect={(date) => {
                                            setSelectedDay(date);
                                            setCurrentMonth(date);
                                        }}
                                        month={currentMonth}
                                        onMonthChange={setCurrentMonth}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {error ? (
                        <p className="error-message">{error}</p>
                    ) : caixas.length === 0 ? (
                        <p className="text-center my-5">{getEmptyMessage()}</p>
                    ) : (
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4 mt-1">
                            {caixas.map((caixa, index) => renderCaixaCard(caixa, index))}
                        </div>
                    )}
                </div>

                {isModalOpen && (
                    <AbrirCaixaModal
                        onClose={() => setIsModalOpen(false)}
                        onCaixaAtualizado={() => fetchCaixas()}
                    />
                )}

                {isModalFecharCaixaOpen && (
                    <FecharCaixaModal
                        onClose={() => setIsModalFecharCaixaOpen(false)}
                        caixa={caixaSelecionado}
                        onCaixaAtualizado={() => fetchCaixas()}
                    />
                )}

                {isModalOperacoesOpen && (
                    <OperacoesCaixaModal
                        onClose={() => setIsModalOperacoesOpen(false)}
                        caixa={caixaSelecionado}
                        activeTab={activeTab}
                    />
                )}

                {isModalReabrirCaixaOpen && (
                    <ReabrirCaixaModal
                        onClose={() => setIsModalReabrirCaixaOpen(false)}
                        caixa={caixaSelecionado}
                        onCaixaAtualizado={() => fetchCaixas()}
                    />
                )}

                {isModalSangriaSuprimentoOpen && (
                    <SangriaSuprimentoModal
                        onClose={() => setIsModalSangriaSuprimentoOpen(false)}
                        caixa={caixaSelecionado}
                        tipoOperacao={tipoOperacao}
                        onOperacaoRealizada={() => fetchCaixas()}
                    />
                )}
            </div>
            <div style={{ height: '50px' }}></div>
        </div>
    );
};

export default Caixas; 